<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      :before-close="resetValidation('testimonial')"
      @close="close"
      @open="open"
    >
      <el-form ref="testimonial" :model="testimonial" label-position="top">
        <el-form-item
          label="Full Name"
          prop="full_name"
          :rules="[{ required: true, message: 'full name is required' }]"
        >
          <el-input type="text" v-model="testimonial.full_name" clearable />
        </el-form-item>
        <el-form-item
          label="User Title"
          prop="user_type_id"
          :rules="[{ required: true, message: 'user title is required' }]"
        >
          <el-select
            v-model="testimonial.user_type_id"
            clearable
            filterable
            class="mr10"
          >
            <el-option
              v-for="a in user_types.data"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <div>
          <p class="inline-eye">Content</p>
          <i
            class="el-icon-view ml10"
            @click="openPreview(testimonial.content)"
          ></i>
        </div>
        <el-form-item prop="content">
          <vue-editor
            v-model="testimonial.content"
            :editorToolbar="customToolbar"
          />
        </el-form-item>
        <el-form-item label="Rating" prop="rating">
          <el-input type="number" v-model="testimonial.rating" clearable />
        </el-form-item>
        <el-form-item label="Link" prop="link">
          <el-input type="text" v-model="testimonial.link" clearable />
        </el-form-item>
        <el-form-item label="Link Youtube" prop="link_youtube">
          <el-input type="text" v-model="testimonial.link_youtube" clearable />
        </el-form-item>
        <el-form-item label="Position" prop="position">
          <el-input type="number" v-model="testimonial.position" clearable />
        </el-form-item>
        <p>Image</p>
        <el-upload
          :action="`${url}cms/testimonial/upload`"
          :headers="headers"
          accept="image/*"
          :on-success="onSuccess"
          :on-error="onError"
          :on-remove="onRemove"
          :on-exceed="onExceed"
          :limit="1"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">Click to upload</el-button>
          <div slot="tip" class="el-upload__tip">jpg/jpeg/png files</div>
        </el-upload>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },
  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      image: { name: '', url: '' }
    }
  },

  computed: {
    dialogTitle: function() {
      if (
        typeof this.testimonial.id !== 'undefined' &&
        this.testimonial.id !== null
      )
        return 'Edit Testimonial'
      else {
        return 'Insert Testimonial'
      }
    },
    ...mapState('testimonial', [
      'loading',
      'testimonial',
      'data',
      'dialog',
      'user_types'
    ])
  },

  methods: {
    ...mapActions('testimonial', ['update', 'insert', 'getUserTypes']),
    ...mapMutations('testimonial', ['setSelectedTestimonial', 'setDialog']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      if (
        typeof this.testimonial.id !== 'undefined' &&
        this.testimonial.id !== null
      )
        this.update(this.testimonial.id)
      else this.insert()
    },

    onSuccess(response, file) {
      this.testimonial.image_url = response.response.message
      this.$message({
        type: 'success',
        message: `File ${file.name} uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.testimonial.image_url = null
    },

    onExceed() {
      this.$message({
        type: 'error',
        message: 'Only one image can be uploaded'
      })
    },

    open() {
      this.fileList = []
      if (
        typeof this.testimonial.image_url !== 'undefined' &&
        this.testimonial.image_url !== null
      ) {
        this.image.url = this.testimonial.image_url
        //this.image.name = this.image.url.substr(this.image.url.lastIndexOf("/")+1)
        this.fileList.push(this.image)
      }
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    close() {
      this.setDialog(false)
    },

    resetValidation(formName) {
      if (typeof this.$refs[formName] != 'undefined') {
        this.$refs[formName].fields
          .find(f => f.prop == 'full_name')
          .clearValidate()
        this.$refs[formName].fields
          .find(f => f.prop == 'user_type_id')
          .clearValidate()
      }
    }
  },
  created() {
    this.getUserTypes()
  }
}
</script>

<style scoped>
.el-upload-list--picture .el-upload-list__item-thumbnail {
  width: auto;
  height: 350px;
}
.inline-eye {
  display: inline-block;
}
</style>
